<template>
  <div class="shownotes" :class="{'shownotes--dark-mode': darkMode}">
    <div v-html="preface" class="subtitle"></div>
    <div v-html="shownotes"/>
  </div>
</template>

<script>
import { mapState } from 'redux-vuex';
import select from '@/store/selectors';
import store from '@/store';
import { toggleTab } from '@/store/actions/tabs';

export default {
  computed: {
    preface() {
      return this.subtitle || this.summary.replaceAll('\n', '<br>');
    },
  },
  data: mapState({
    shownotes: select.shownotes,
    subtitle: select.episode.subtitle,
    summary: select.episode.summary,
    darkMode: select.customOptions.darkMode,
  }),
  methods: {
    closeTab() {
      store.dispatch(toggleTab('shownotes'));
    },
  },
};

</script>

<style lang="scss" scoped>
  @import '~@/assets/scss/tokens/tab.scss';

  .shownotes {
    @extend %tab-wrapper;
    color: #000000;
    font-size: 14px;
    overflow-y: scroll;
    scrollbar-highlight-color: rgb(153, 153, 153);

    &--dark-mode {
      color: #FFFFFF;
    }
  }

  .shownotes :deep(ul) {
    list-style-type: disc;
    padding-inline-start: 20px;
  }

  .shownotes::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .shownotes::-webkit-scrollbar-thumb {
    -webkit-border-radius: 6px;
    border-radius: 6px;
    background: rgb(153, 153, 153);
  }

  .subtitle {
    margin-bottom:10px
  }

</style>
